import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=2f0f18e8&scoped=true"
import script from "./Wizard.vue?vue&type=script&lang=js"
export * from "./Wizard.vue?vue&type=script&lang=js"
import style0 from "./Wizard.vue?vue&type=style&index=0&id=2f0f18e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0f18e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f0f18e8')) {
      api.createRecord('2f0f18e8', component.options)
    } else {
      api.reload('2f0f18e8', component.options)
    }
    module.hot.accept("./Wizard.vue?vue&type=template&id=2f0f18e8&scoped=true", function () {
      api.rerender('2f0f18e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/partner-signup/Wizard.vue"
export default component.exports